"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyPurchaseMotionEligibility = void 0;

var _getPurchaseMotionData = require("self-service-api/api/getPurchaseMotionData");

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var _UpgradeProductProperties = _interopRequireDefault(require("self-service-api/constants/UpgradeProductProperties"));

var _createProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty");

var PurchaseMotionTypes = _interopRequireWildcard(require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _logError = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/logError"));

var PROPERTY_KEY = 'purchaseMotionEligibility';

var getPropertyPurchaseMotionEligibility = function getPropertyPurchaseMotionEligibility() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      upgradeProduct = _ref.upgradeProduct;

  var productProperty = _UpgradeProductProperties.default[upgradeProduct];

  if (!productProperty) {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, []);
  }

  var merchandiseId = _UpgradeProductProperties.default[upgradeProduct].merchandiseId;

  if (!merchandiseId) {
    // An upgradeProduct will not have an associated merchandiseId if
    // it is a concept that we've created rather than an actual SKU. I.e. GENERAL
    return (0, _createProperty.createProperty)(PROPERTY_KEY, [PurchaseMotionTypes.TALK_TO_SALES]);
  }

  var merchandiseIdToUse = merchandiseId; //Enterprise upgrade product can be used when a feature can be unlocked by any enterprise SKU
  // Use Marketing Enterprise as a proxy for purchase motion eligibility of enterprise level SKUs

  if (upgradeProduct === _UpgradeProducts.ENTERPRISE) {
    merchandiseIdToUse = _MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE;
  }

  return (0, _getPurchaseMotionData.getPurchaseMotionData)([merchandiseIdToUse]).then(function (purchaseMotionData) {
    var purchaseMotionEligibility = purchaseMotionData.purchaseMotions[merchandiseIdToUse] || [];
    var propertyValue = purchaseMotionEligibility.map(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          key = _ref2.key;

      return key;
    });
    return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
  }).catch(function (err) {
    (0, _logError.default)('getPropertyPurchaseMotionEligibility', err);
    return (0, _createProperty.createProperty)(PROPERTY_KEY, []);
  });
};

exports.getPropertyPurchaseMotionEligibility = getPropertyPurchaseMotionEligibility;